import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const RedirectHandler = () => {
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const redirectUri = params.get('redirectUri');
        if (redirectUri) {
            history.replace(redirectUri);
        } else {
            history.replace('/');
        }
    }, [location, history]);

    return null;
};

export default RedirectHandler;
